import { render, staticRenderFns } from "./DealsSection.vue?vue&type=template&id=a161b9ca&scoped=true"
import script from "./DealsSection.vue?vue&type=script&lang=js"
export * from "./DealsSection.vue?vue&type=script&lang=js"
import style0 from "./DealsSection.vue?vue&type=style&index=0&id=a161b9ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a161b9ca",
  null
  
)

export default component.exports